import { render } from "./EmployeeEntry.vue?vue&type=template&id=ebab336a"
import script from "./EmployeeEntry.vue?vue&type=script&lang=js"
export * from "./EmployeeEntry.vue?vue&type=script&lang=js"

import "./EmployeeEntry.vue?vue&type=style&index=0&id=ebab336a&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__